import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { getVideoSubscription, checkIfEmailExists, getAndroidSubscriptionDetails } from "../../Subscription/service";
import { getUserSubscription } from "../../../network/service"
import { registerUser } from '../Register/service';
import { login } from '../Login/service';
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import { analytics2, authenticate } from "../../../network/service";
import { getUser } from "../../../Redux/UserSlice/UserSlice";
import { getLanguageModal } from '../../../Redux/LanguageModal/languageModalSlice';
import { getAccessToken } from "../../../Redux/AToken/ATokenSlice";
import { getUserDetails } from "../../../Redux/UserDetailsSlice/UserDetailsSlice";
import { getUserSubscriptionData } from "../../../Redux/UserSubscriptionDetails/userSubscriptionSlice";
import LoginModal from "../../../Components/Modals/LoginModal/LoginModal";
import { stripeSession, applyCouponCode, squareSubscription, cinetPayApiSession } from "../../Subscription/service";

import Translate, { useTranslateText } from "../../../Components/MultiLanguage/Translate";
import { bogSubscription } from "../../../Screens/Subscription/service";
import { PayPalScriptProvider, } from "@paypal/react-paypal-js";
import PaypalButtonWrapper from "../../Subscription/PaypalButtonWrapper";
const Checkout = () => {

    const location = useLocation();
    const navigate = useNavigate();
    const projectInfo = useSelector((state) => state?.projectInfo?.value);
    const accessToken = useSelector((state) => state?.accessToken?.value);
    const androidData = useSelector((state) => state?.deviceSubscription?.value);
    const dispatch = useDispatch();
    const user = useSelector((state) => state?.user?.value);
    const userData = useSelector((state) => state?.userDetails?.value);
    const userSubscriptionData = useSelector((state) => state?.userSubscription?.value);
    const translateText = useTranslateText();
    const paypalRef = useRef(null);
    const appInfo = {
        projectDetails: projectInfo,
        accessToken: accessToken,
    };
    const videoId = location?.state?.videoId;
    const eventId = location?.state?.eventId;
    const showId = location?.state?.showId;
    const subscriptionId = location?.state?.subscriptionId;
    const subscriptionPrice = location?.state?.subscriptionPrice;
    const tvCode = location?.state?.code;
    const activeLogin = location?.state?.activeLogin;
    const urlParams = new URLSearchParams(window.location.search);
    const androidToken = urlParams.get("antkn");
    const videoIdAndroid = urlParams.get("vd");
    const eventIdAndroid = urlParams.get("ed");
    const channelIdAndroid = urlParams.get("cn");
    const channelId = location?.state?.channelId;
    const gateways = projectInfo?.projectConfig?.config?.WEBSITE_PAYMENT_GATEWAYS;

    const [subscriptions, setSubscriptions] = useState([]);
    const [activeSubscriptions, setActiveSubscriptions] = useState([]);
    const [selectedPlan, setSelectedPlan] = useState();
    const [selectedPlanPrice, setSelectedPlanPrice] = useState();
    const [activeDetailsPlan, setActiveDetailsPlan] = useState([]);
    const [showPassword, setShowPassword] = useState(false);
    const [activeScreen, setActiveScreen] = useState('register');
    const [isOkToProceed, setIsOkToProceed] = useState();
    const [email, setEmail] = useState();
    const [password, setPassword] = useState();
    const [userResponse, setUserResponse] = useState()
    const [error, setError] = useState({});
    const [showAlreadyExistMessage, setShowAlreadyExistMessage] = useState(false);
    const [maskedPassword, setMaskedPassword] = useState();
    const [isFocused, setIsFocused] = useState(false);
    const [resetPasswordMessage, setResetPasswordMessage] = useState();
    const [emailLoginModal, setEmailLoginModal] = useState(false);
    const [haveCoupon, setHaveCoupon] = useState(false);
    const [couponCode, setCouponCode] = useState();
    const [couponSuccess, setCouponSuccess] = useState(false)
    const [couponProcessing, setCouponProcessing] = useState(false)
    const [paymentGateways, setPaymentGateways] = useState({
        cinetPay: false,
        stripe: false,
        paypal: false,
        ideabiz: false,
        square: false,
        bog: false,
    });

    const [subscriptionMethodDiv, setSubscriptionMethodDiv] = useState(false);
    const [showContinueButton, setShowContinueButton] = useState(true);
    const [selectedSubscriptionData, setSelectedSubscriptionData] = useState({});
    const [showPaypal, setShowPaypal] = useState(false);
    const [showPaypalContainer, setShowPaypalContainer] = useState(false);
    const [isFree, setIsFree] = useState(location?.state?.isFree);

    const checkoutSubId = location?.pathname.split('/checkout/')[1];
    useEffect(() => {
        if (checkoutSubId) {
            setIsFree(false);
        }
    }, [checkoutSubId]);
    useEffect(() => {

        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });

        fetchSubscriptionList();
        user && setActiveScreen('login-success');

        const queryParams = new URLSearchParams(window.location.search);

        if (queryParams.get("new-login") === "1") {
            setActiveScreen('login');
        } else {
            //leave it
        }

        localStorage.removeItem("couponId");
        setHaveCoupon(false);

    }, []);

    useEffect(() => {

        if (androidToken) {
            const deviceId = urlParams.get("deviceId");
            const info = {
                projectConfig: projectInfo?.projectConfig,
                geoInfo: projectInfo?.geoInfo,
                device_id: deviceId,
            };
            fetchAndroidSubscriptionDetails(androidToken, info);
        } else {
            // do nothing
        }

    }, [androidToken])

    useEffect(() => {
        if (videoId || showId) {
            fetchSubscriptionList();
            user && setActiveScreen('login-success');
        } else {
            //leave now
        }
    }, [videoId, showId, eventId])

    useEffect(() => {
        activeLogin && setActiveScreen('login')
    }, [activeLogin])

    useEffect(() => {
        if (selectedPlan) {
            localStorage.setItem("selectedSubId", selectedPlan);
            localStorage.setItem("deviceType", androidToken || localStorage.getItem('isAndroid') == 'true' ? "android-web" : "web");
            localStorage.setItem("selectedAmount", selectedPlanPrice);
            localStorage.removeItem("couponId");
            setHaveCoupon(false);
        } else {
            //keep waiting
        }

    }, [selectedPlan])

    useEffect(() => {
        if (password) {
            const mask = '*'?.repeat(password.length);
            setMaskedPassword(mask);
        } else {
            setMaskedPassword();
        }
    }, [password]);

    useEffect(() => {
        if (activeScreen == 'register' || activeScreen == 'login-success') {
            setIsOkToProceed(true)
        } else {
            setIsOkToProceed(false)
        }

        setHaveCoupon(false)

    }, [activeScreen])

    useEffect(() => {
        if (showAlreadyExistMessage) {
            setTimeout(() => {
                setShowAlreadyExistMessage(false)
            }, 15 * 1000);
        }
    }, [showAlreadyExistMessage])

    useEffect(() => {
        if (resetPasswordMessage) {
            setTimeout(() => {
                setResetPasswordMessage('')
            }, 5 * 1000);
        }
    }, [resetPasswordMessage])

    useEffect(() => {
        if (!haveCoupon) {
            setError({
                ...error,
                ['coupon']: ''
            });
            setCouponCode();
        } else {
            //do nothing
        }
    }, [haveCoupon])

    useEffect(() => {

        if (userSubscriptionData?.data?.length > 0) {
            const haveValidSubscription = subscriptionCheck();

            if (haveValidSubscription) {
                navigate(-1)
            }
        } else {
            // fail silently
        }

    }, [userSubscriptionData])

    useEffect(() => {
        if (gateways) {
            setPaymentGateways({
                cinetPay: gateways.includes('CINETPAY'),
                stripe: gateways.includes('STRIPE'),
                paypal: gateways.includes('PAYPAL'),
                ideabiz: gateways.includes('IDEABIZ'),
                square: gateways.includes('SQUARE'),
                bog: gateways.includes('BOG'),
            });
        } else {
            console.log('WEBSITE_PAYMENT_GATEWAYS not found');
        }
    }, [])

    useEffect(() => {
        if (showPaypalContainer) {
            document.addEventListener("mousedown", handleClickOutside);
        } else {
            document.removeEventListener("mousedown", handleClickOutside);
        }
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [showPaypalContainer]);

    const handleClickOutside = (event) => {
        if (paypalRef.current && !paypalRef.current.contains(event.target)) {
            setShowPaypalContainer(false);
            {
                !subscriptionMethodDiv && setShowContinueButton(true);
            }

        }
    };

    const fetchAndroidSubscriptionDetails = async (androidToken, info) => {

        const data = {
            projectDetails: info,
            accessToken: accessToken,
        };
        const response = await getAndroidSubscriptionDetails(
            data,
            androidToken
        );

        if (response?.status === 200) {

            localStorage.setItem("userId", response?.data?.data[0]?.user_id);
            localStorage.setItem("isAndroid", true);
            localStorage.setItem("deviceType", "android-web");
            localStorage.setItem('selectedLanguageCode', response?.data?.data[0]?.language?.short_code);
            localStorage.setItem('selectedLanguageId', response?.data?.data[0]?.language?.language_id);
            updateLocalStorage(response)
            setUserResponse(response)
            dispatch(
                getLanguageModal({
                    languageModal: {
                        selectedLanguageCode: response?.data?.data[0]?.language?.short_code
                    }
                }))
            const url = new URL(window.location.href);
            const params = new URLSearchParams(url.search);

            // Remove the 'antkn & deviceId' parameters
            params.delete('antkn');
            params.delete('deviceId');

            const newUrl = `${url.pathname}?${params.toString()}`;
            window.location.href = newUrl;
        }
    };
    const fetchSubscriptionList = async () => {

        let typeID;
        let typeName;

        if (videoIdAndroid) {
            typeID = videoIdAndroid;
            typeName = 'video';
        } else if (eventIdAndroid) {
            typeID = eventIdAndroid;
            typeName = 'event';
        } else if (channelIdAndroid) {
            typeID = channelIdAndroid;
            typeName = 'channel';
        } else if (videoId) {
            typeID = videoId;
            typeName = 'video';
        } else if (showId) {
            typeID = showId;
            typeName = 'show';
        } else if (eventId) {
            typeID = eventId;
            typeName = 'event';
        }
        else if (channelId) {
            typeID = channelId;
            typeName = 'channel';
        }

        const response = await getVideoSubscription(appInfo, typeID, typeName, 'list');
        const subscriptionResponse = await getVideoSubscription(appInfo, typeID, typeName);

        if (subscriptionResponse?.status === 200) {
            setActiveSubscriptions(subscriptionResponse?.data?.data);
        }
        if (response?.status === 200) {
            setSubscriptions(response?.data?.data);

            if (subscriptionId) {

                await fetchUserSubscriptionDetails()


                setSelectedPlan(subscriptionId)
                setSelectedPlanPrice(subscriptionPrice)
            } else {
                if (response?.data?.data?.length > 0) {
                    setSelectedPlan(response?.data?.data[0]?.subscription_id)
                    setSelectedPlanPrice(response?.data?.data[0]?.price)
                    setSelectedSubscriptionData(response?.data?.data[0]);
                } else {
                    setSelectedPlan(0);
                    setSelectedPlanPrice(0);
                }

            }

        }
    };

    const fetchUserSubscriptionDetails = async () => {
        const userSubResponse = await getUserSubscription(appInfo);
        if (userSubResponse?.status === 200) {
            dispatch(
                getUserSubscriptionData({
                    userSubscription: userSubResponse?.data,
                })
            );
        }
    };

    const linkHandler = (path) => {
        navigate(path);
    }

    const handleEmailValidation = async () => {

        if (activeScreen !== 'register') {
            return false;
        } else {

            const isEmailValid = await validateEmail(email);
            if (isEmailValid) {
                setError({
                    ['email']: '',
                    ['password']: ''
                });
                // register case: check whether email already exist or not.

                email && isEmailAlreadyRegistered()
            } else {
                setError({
                    ['email']: <Translate textKey={'invalid_email_id'} />,
                    ['password']: ''
                });
            }
        }

    }

    const validateEmail = async (email) => {
        const regex = /^[^@]+@[^@]+\.[^@]+$/;
        return regex.test(email);
    };

    const validatePassword = async (password) => {

        if (password && password != '') {
            return true;
        } else {
            setError({
                ...error,
                ['password']: <Translate textKey={'password_required'} />
            })
            return false;
        }
    }

    const isEmailAlreadyRegistered = async () => {
        const response = await checkIfEmailExists(appInfo, { user_email: email });

        if (response?.status == 201) {
            // toast.error(response?.data?.message)
            setShowAlreadyExistMessage(true);
            setActiveScreen('login')
        } else {
            console.log(response?.data?.message)
        }
    }

    const handleLoginSubmit = async () => {

        const isEmailValid = await validateEmail(email);
        const isPasswordValid = await validatePassword(password);

        if (isEmailValid && isPasswordValid) {
            setError({})
            const response = await login({ email, password }, appInfo);
            if (response?.status === 200) {
                updateLocalStorage(response)
                setUserResponse(response)
                setActiveScreen('login-success') // display user details and info like please select a plan and click on the continue button to proceed the payment.
            } else if (response?.status == 202) {
                setResetPasswordMessage(response?.data?.message)
            }
        } else {
            manageErrorMessage(isEmailValid, isPasswordValid);
        }


    }

    const subscriptionCheck = () => {
        const userSub = userSubscriptionData?.data;
        const videoSub = activeSubscriptions;
        return userSub?.some((user) => videoSub?.some((video) => user?.sub_id === video?.subscription_id));
    };

    const handleSubmit = async () => {

        if (activeScreen == 'register') {
            const isEmailValid = await validateEmail(email);
            const isPasswordValid = await validatePassword(password);

            if (isEmailValid && isPasswordValid) {
                const response = await registerUser(appInfo, { email, password });
                if (response?.status == 200) {
                    setUserResponse(response)
                    updateLocalStorage(response)
                    if (gateways?.length > 1) {
                        setSubscriptionMethodDiv(true);
                        setShowContinueButton(false);
                    } else {
                        proceedToPayment(gateways[0])
                    }
                }

            } else {
                manageErrorMessage(isEmailValid, isPasswordValid);
            }
        } else {
            if (user) {
                if (selectedPlan == 0) { // Free Account scenario
                    navigate(-1)
                    return;
                }
                if (gateways?.length > 1) {
                    setSubscriptionMethodDiv(true);
                    setShowContinueButton(false);

                } else {
                    proceedToPayment(gateways[0])
                }
            } else {
                switchToAnotherAccount()
                setResetPasswordMessage('Invalid credentials');
            }

        }

    }

    const proceedToPayment = async (selectedMethod) => {

        setShowContinueButton(false);
        if (selectedPlan == 0) { // Free Account scenario
            navigate(-1)
            return;
        } else {

            const paymentInfo = {
                subId: selectedPlan,
                couponId: couponCode?.couponId,
            };

            try {
                switch (selectedMethod) {
                    case "STRIPE":
                        stripeApi(paymentInfo);
                        break;

                    case "PAYPAL":
                        setShowPaypal(true);
                        setShowPaypalContainer(true);
                        break;

                    case "BOG":
                        bogPayment();
                        break;

                    case "CINETPAY":
                        cinetPayApi();
                        break;

                    case "SQUARE":
                        squarePayment();
                        break;

                    case "IDEABIZ":
                        ideabizHandler();
                        break;

                    default:
                        console.log("Invalid Payment Method Selected");
                }
            } catch (err) {
                toast.error(err?.response?.data?.message || "Payment failed", {
                    position: "bottom-center",
                });
            }

        }
    }



    const updateLocalStorage = async (response) => {

        const userDetails = response ? response?.data?.data[0] : userResponse?.data?.data[0];
        if (userDetails?.user_id) {
            localStorage.setItem("userId", userDetails?.user_id);
            localStorage.setItem("selectedSubId", selectedPlan);
            localStorage.setItem("deviceType", androidToken || localStorage.getItem('isAndroid') == 'true' ? "android-web" : "web");
            localStorage.setItem("selectedAmount", selectedPlanPrice);

            tokenAuthenticate();
            updateDeviceAnalytics(
                userDetails?.user_id,
                appInfo,
                userDetails?.user_email
            );
            dispatch(
                getUser({
                    user: userDetails?.user_id,
                })
            );

            dispatch(
                getUserDetails({
                    userDetails
                }));

            await fetchUserSubscriptionDetails();



        } else {
            console.log('user details not found');

        }
    }

    const updateDeviceAnalytics = async (userId, appInfo, userEmail) => {
        await analytics2(userId, appInfo, userEmail);
    };

    const tokenAuthenticate = async () => {
        const response = await authenticate(appInfo);
        if (response?.status === 200) {
            localStorage.setItem('selectedLanguageCode', response?.data?.user_language?.short_code);
            localStorage.setItem('selectedLanguageId', response?.data?.user_language?.language_id);
            dispatch(
                getLanguageModal({
                    languageModal: {
                        selectedLanguageCode: response?.data?.user_language?.short_code
                    }
                }))
            dispatch(
                getAccessToken({
                    accessToken: response?.data?.token,
                })
            );
            dispatch(
                getUserDetails({
                    userDetails: response?.data,
                })
            );
        }
    };

    const switchToAnotherAccount = async () => {
        localStorage.clear();
        setActiveScreen('login');
        setEmail();
        setPassword();
        setMaskedPassword();
        dispatch(
            getUser({
                user: null,
            })
        );

        window.location.href = window.location.href + '?new-login=1';
    }



    const manageErrorMessage = (isEmailValid, isPasswordValid) => {

        const passwordMsg = isPasswordValid ? '' : <Translate textKey={'password_required'} />;
        const emailMsg = isEmailValid ? '' : <Translate textKey={'email_required_message'} />;
        setError({
            password: passwordMsg,
            email: emailMsg
        });
    }

    const applyCouponCodeHandler = () => {

        setCouponProcessing(true);

        if (!couponCode?.couponCode) {
            setCouponProcessing(false);
            setError({
                ...error,
                ['coupon']: <Translate textKey={'enter_coupon_code'} />
            });
        } else {
            couponCodeApi();
        }
    };

    const couponCodeApi = async () => {
        try {
            const couponCodeResponse = await applyCouponCode(
                appInfo,
                couponCode?.couponCode,
                selectedPlan
            );

            if (couponCodeResponse?.status === 200) {
                setCouponProcessing(false);
                setError({
                    ...error,
                    ['coupon']: ''
                })
                setCouponSuccess(true);
                localStorage.setItem("couponId", couponCodeResponse?.data?.data?.coupon_id);

                setCouponCode({
                    ...couponCode,
                    couponId: couponCodeResponse?.data?.data?.coupon_id,
                });

            } else {
                setCouponProcessing(false);
                setError({
                    ...error,
                    ['coupon']: couponCodeResponse?.data?.message
                });
            }
        } catch (err) { }
    };

    const stripeApi = async () => {
        if (couponSuccess) {
            const paymentInfo = {
                subId: selectedSubscriptionData?.subscription_id,
                couponId: couponCode?.couponId,
            };
            try {
                const stripeResponse = await stripeSession(appInfo, paymentInfo);
                if (stripeResponse?.status === 200) {
                    window.open(stripeResponse?.data?.url, "_self")

                }
            } catch (err) {
                toast.error(err?.response?.data?.message, {
                    position: "bottom-center",
                });
            }
        } else {
            const paymentInfo = {
                subId: selectedSubscriptionData?.subscription_id,
            };
            try {
                const stripeResponse = await stripeSession(appInfo, paymentInfo);

                if (stripeResponse?.status === 200) {
                    window.open(stripeResponse?.data?.url, "_self")
                }
            } catch (err) {
                toast.error(err?.response?.data?.message, {
                    position: "bottom-center",
                });
            }
        }
    };
    const cinetPayApi = async () => {

        const paymentInfo = {
            subId: selectedSubscriptionData?.subscription_id,
        };
        try {
            const cinetPayApiResponse = await cinetPayApiSession(appInfo, paymentInfo);
            if (cinetPayApiResponse?.status === 200) {
                window.open(cinetPayApiResponse?.data?.data, "_self")
            }
        } catch (err) {
            toast.error(err?.response?.data?.message, {
                position: "bottom-center",
            });
        }

    };

    const squarePayment = async () => {
        const paymentInfo = {
            subId: selectedSubscriptionData?.subscription_id,
        };
        try {
            const squareResponse = await squareSubscription(appInfo, paymentInfo);
            if (squareResponse?.status === 200) {
                window.open(squareResponse?.data?.data?.url, "_self")
            }
        } catch (err) {
            toast.error(err?.response?.data?.message, {
                position: "bottom-center",
            });
        }
    }

    const bogPayment = async () => {
        const paymentInfo = {
            subId: selectedPlan,
        };
        try {

            const bogResponse = await bogSubscription(appInfo, paymentInfo);
            if (bogResponse?.status === 200) {
                toast.success(bogResponse?.data?.message, {
                    position: "bottom-center",
                });
                localStorage.setItem("bogOrderId", bogResponse?.data?.data?.order_id,);
                window.open(bogResponse?.data?.data?.redirect_url, "_self")
            }
        } catch (err) {
            toast.error(err?.response?.data?.message, {
                position: "bottom-center",
            });
        }
    }
    const ideabizHandler = () => {
        localStorage.setItem("selectedAmount", selectedSubscriptionData?.price);
        navigate(`/ideabiz`, {
            state: { subscription: selectedSubscriptionData, appInfo },
        })
    }
    return (
        <div className="checkout-page">
            <div className="wrapper">
                {
                    emailLoginModal &&
                    <LoginModal isEmailForm={true} setEmailLoginModal={setEmailLoginModal} tvCode={tvCode} />
                }
                <div className="left">
                    <div>
                        <span className="heading">
                            {activeScreen == 'register' ? <Translate textKey={'create_your_account'} /> : activeScreen == 'login-success' ? <Translate textKey={'account_confirmation'} /> : <Translate textKey={'access_your_account'} />}
                        </span>
                        {activeScreen != 'login-success' && <div className="sign-in-link-section">
                            {activeScreen == 'register' ? <>
                                <span className="sub-heading"><Translate textKey={'register_sign_in_text'} /></span>
                                <span className="signin-link" onClick={() => { setActiveScreen('login') }}><Translate textKey={'sign_in'} /></span>
                            </>
                                : <>
                                    <span className="sub-heading"><Translate textKey={'create_new_account'} /></span>
                                    <span className="signin-link" onClick={() => { setActiveScreen('register') }}><Translate textKey={'register'} /></span>
                                </>}
                        </div>}

                    </div>
                    {activeScreen != 'login-success' ? <div className="user-section">

                        {projectInfo?.projectConfig?.config?.LOGIN_WITH_MAGIC_LINK_REQUIRED === "true" && activeScreen == 'login' &&
                            <> <div className="login-with-email-wrapper"
                                onClick={() => {
                                    localStorage.setItem('redirectFromNewCheckoutPage', 'true')
                                    setEmailLoginModal(true);
                                }}
                            >
                                <button className="--button-color" ><Translate textKey={'sign_in_via_email'} /></button>
                            </div>

                                <div className="seperate"><div className="line"></div><span className="devider"><Translate textKey={'or'} /></span><div className="line"></div></div>
                                <div className="login-with-email-password">
                                    <span><Translate textKey={'sign_in_via_email_password'} /></span>
                                </div>
                            </>
                        }
                        <div>
                            <input type="email" placeholder={translateText("email")}
                                onChange={(event) => {
                                    setEmail(event?.target?.value);
                                }}

                                onFocus={() => { setError({ ...error, ['email']: '' }) }}


                            />

                            {showAlreadyExistMessage && <div className="existing-user-message"><span className="close-message"
                                onClick={() => { setShowAlreadyExistMessage(false) }}>x</span><p><Translate textKey={'existing_user_message'} /></p></div>}

                            {error?.email && <span className="error">{error.email}</span>}
                        </div>
                        <div className="password-section">
                            {isFocused || showPassword ? <>{password && <span className="password-show"
                                onClick={() => { setShowPassword(false) }}
                            ><svg width={20} height={20} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M2 2L22 22" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M6.71277 6.7226C3.66479 8.79527 2 12 2 12C2 12 5.63636 19 12 19C14.0503 19 15.8174 18.2734 17.2711 17.2884M11 5.05822C11.3254 5.02013 11.6588 5 12 5C18.3636 5 22 12 22 12C22 12 21.3082 13.3317 20 14.8335" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M14 14.2362C13.4692 14.7112 12.7684 15.0001 12 15.0001C10.3431 15.0001 9 13.657 9 12.0001C9 11.1764 9.33193 10.4303 9.86932 9.88818" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg></span>
                            }</> : <>{password && <span className="password-show"
                                onClick={() => { setShowPassword(true) }}
                            ><svg width={20} height={20} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M1 12C1 12 5 4 12 4C19 4 23 12 23 12" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M1 12C1 12 5 20 12 20C19 20 23 12 23 12" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> <circle cx="12" cy="12" r="3" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></circle> </g></svg></span>}</>}

                            <input type='text'
                                placeholder={translateText(activeScreen == 'register' ? "create_password" : 'password')}
                                onFocus={() => {
                                    handleEmailValidation();
                                    setIsFocused(true); // Mark as focused to show the actual password while editing
                                }}
                                value={isFocused || showPassword ? password : maskedPassword}
                                onChange={(event) => {
                                    setPassword(event?.target?.value);
                                }}
                                onBlur={() => setIsFocused(false)}
                            />
                            {error?.password && <span className="error">{error.password}</span>}
                            {resetPasswordMessage && activeScreen == 'login' &&
                                <div>
                                    <p className="login-success-message error">{resetPasswordMessage}</p>
                                </div>}

                            {!resetPasswordMessage && activeScreen == 'login' && projectInfo?.projectConfig?.config?.CUSTOM_LOGIN_SCREEN_MESSAGE &&
                                <div>
                                    <p className="login-success-message error">{projectInfo?.projectConfig?.config?.CUSTOM_LOGIN_SCREEN_MESSAGE}</p>
                                </div>}


                        </div>
                        {activeScreen == 'login' && <div className="forgot-link">
                            <Link to={'/forgot-password'}><div className="sub-heading link forgot-text"><Translate textKey={'forgot_password'} /></div></Link>
                            <button className="login-button" onClick={() => { handleLoginSubmit() }}><Translate textKey={'sign_in'} /></button>
                        </div>}



                    </div> : <div className="user-section">
                        {userData && <p className="login-success-message"><Translate textKey={'logged_as'} /> <span className="link">{userData?.user_email}</span>. <Translate textKey={'select_plan_message'} /></p>}
                        <>
                            <span className="sub-heading"><Translate textKey={'switch_account'} /></span>
                            <span className="link" onClick={() => { switchToAnotherAccount() }}> <Translate textKey={'sign_in'} /></span>
                        </>
                    </div>}

                    {activeScreen != 'login' && <div className="coupon-wrapper">
                        <div className="coupon-link" >
                            <input type="checkbox" className="coupon-check" checked={haveCoupon} onChange={() => { setHaveCoupon(!haveCoupon) }} />
                            <div className="sub-heading link forgot-text coupon-text" onClick={() => { setHaveCoupon(!haveCoupon) }}><Translate textKey={'having_coupon'} /></div>
                        </div>
                        {
                            haveCoupon &&
                            <div className="coupon-section">
                                <input type='text' placeholder={translateText("enter_coupon_code")} onFocus={() => {
                                    setError({
                                        ...error,
                                        ['coupon']: ''
                                    })
                                }}

                                    onChange={(event) => {
                                        setCouponCode({
                                            ...couponCode,
                                            ['couponCode']: event?.target?.value
                                        })
                                    }} />
                                <button onClick={() => { !couponProcessing && applyCouponCodeHandler() }}>{couponProcessing ? 'Processing...' : 'Apply'}</button>
                            </div>
                        }
                        {error?.coupon && <span className="error">{error.coupon}</span>}
                        {couponSuccess && <span className="success">{'The coupon has been applied successfully!'}</span>}
                    </div>}
                </div>
                <div className="right">
                    <div>
                        <span className="heading">
                            <Translate textKey={'select_package'} />
                        </span>
                    </div>
                    <div className="package-section">

                        {
                            subscriptions.length > 0 ? subscriptions.map((item, index) => {
                                return <div className="package-item">
                                    <div className="heading-section">
                                        <div className="heading-wrapper">
                                            <span className="heading">{item?.subscription_name}</span>
                                            <span className="sub-heading">{item?.subscription_text}</span>
                                        </div>
                                        <div className="plan-options-wrapper">
                                            <input type="radio" id={`selected-plan-${index}`} name="selected-plan" checked={selectedPlan == item?.subscription_id ? true : false} onChange={() => { setSelectedPlan(item?.subscription_id); setSelectedPlanPrice(item?.price); setSelectedSubscriptionData(item); }} className="selected-plan plan-options" />
                                        </div>
                                    </div>
                                    {activeDetailsPlan == item?.subscription_id && <div className="plan-description">{item?.description}</div>}
                                    <div className="details" onClick={() => { activeDetailsPlan ? setActiveDetailsPlan() : setActiveDetailsPlan(item?.subscription_id) }}>
                                        {activeDetailsPlan == item?.subscription_id ? <Translate textKey={'see_less'} /> : <Translate textKey={'see_details'} />}
                                    </div>
                                </div>
                            }) : !isFree &&
                            <div className="package-item">
                                <div className="heading-section">
                                    <div className="heading-wrapper">
                                        <span className="sub-heading"><Translate textKey={'subscription_fetch'} /></span>
                                    </div>
                                </div>
                            </div>
                        }

                        {isFree &&
                            <div className="package-item">
                                <div className="heading-section">
                                    <div className="heading-wrapper">
                                        <span className="heading"><Translate textKey={'free_account'} /></span>
                                        <span className="sub-heading"><Translate textKey={'watch_for_free'} /></span>
                                    </div>
                                    <div className="plan-options-wrapper">
                                        <input type="radio" id={`selected-plan-free`} name="selected-plan" checked={subscriptions.length == 0 || selectedPlan == 0} onChange={() => { setSelectedPlan(0); setSelectedPlanPrice(0) }} className="selected-plan plan-options" />
                                    </div>
                                </div>
                            </div>
                        }

                        <div>
                            <p className="disclaimer-text">
                                <Translate textKey={'disclaimer-text'} />&nbsp;{projectInfo.projectConfig.config.TAB_TITLE}'s&nbsp;
                                <span className="link" onClick={() => { linkHandler('/terms-and-conditions') }}><Translate textKey={'terms_of_use'} /></span> <Translate textKey={'and'} /> &nbsp;
                                <span className="link" onClick={() => { linkHandler('/privacy-policy') }}><Translate textKey={'privacy_policy'} />&nbsp;</span><Translate textKey={'disclaimer-text_two'} /> {projectInfo.projectConfig.config.TAB_TITLE} <Translate textKey={'disclaimer-text_three'} />
                            </p>
                        </div>
                        {showContinueButton &&
                            <div className="continue-button" >
                                {isOkToProceed && !couponProcessing && <button className="continue-button" onClick={() => { handleSubmit() }}><Translate textKey={'continue'} /></button>}
                            </div>
                        }

                    </div>


                    {subscriptionMethodDiv && (
                        <div className="subscription-listing">
                            <div className="subscription-heading">
                                <h2><Translate textKey={'choose_payment'} /></h2>
                            </div>
                            <div className="payment-gateways">
                                {gateways.map((gateway, index) => (
                                    <div key={index} className="gateway-item">
                                        {gateway === "BOG" && paymentGateways.bog && (
                                            <div className="payment-method">
                                                <ul className="gateways">
                                                    <li onClick={() => proceedToPayment("BOG")} title={gateway}>
                                                        <div className="imageContainer">
                                                            <img src={require("../../../assets/Images/bog_new.jpg")} alt="BOG" />
                                                        </div>
                                                    </li>
                                                </ul>
                                            </div>
                                        )}

                                        {gateway === "PAYPAL" && paymentGateways.paypal && (
                                            <div className="payment-method">
                                                <ul className="gateways">
                                                    <li onClick={() => proceedToPayment("PAYPAL")} title={gateway}>
                                                        <div className="paypalImageContainer">
                                                            <img src={require("../../../assets/Images/paypal.png")} alt="Paypal" />
                                                        </div>
                                                    </li>
                                                </ul>
                                            </div>
                                        )}

                                        {gateway === "STRIPE" && paymentGateways.stripe && (
                                            <div className="payment-method">
                                                <ul className="gateways">
                                                    <li onClick={() => proceedToPayment("STRIPE")} title={gateway}>
                                                        <div className="imageContainer">
                                                            <img src={require("../../../assets/Images/stripe.png")} alt="Stripe" />
                                                        </div>
                                                    </li>
                                                </ul>
                                            </div>
                                        )}

                                        {gateway === "CINETPAY" && paymentGateways.cinetPay && (
                                            <div className="payment-method">
                                                <ul className="gateways">
                                                    <li onClick={() => proceedToPayment("CINETPAY")} title={gateway}>
                                                        <div className="imageContainer">
                                                            <img src={require("../../../assets/Images/cinetpay.png")} alt="Cinet Pay" />
                                                        </div>
                                                    </li>
                                                </ul>
                                            </div>
                                        )}

                                        {gateway === "SQUARE" && paymentGateways.square && (
                                            <div className="payment-method">
                                                <ul className="gateways">
                                                    <li onClick={() => proceedToPayment("SQUARE")} title={gateway}>
                                                        <div className="imageContainer">
                                                            <img src={require("../../../assets/Images/square.png")} alt="Square" />
                                                        </div>
                                                    </li>
                                                </ul>
                                            </div>
                                        )}

                                        {gateway === "IDEABIZ" && paymentGateways.ideabiz && (
                                            <div className="payment-method">
                                                <ul className="gateways">
                                                    <li onClick={() => proceedToPayment("IDEABIZ")} title={gateway}>
                                                        <div className="imageContainer">
                                                            <img src={require("../../../assets/Images/ideabiz1.png")} alt="Ideabiz" />
                                                        </div>
                                                    </li>
                                                </ul>
                                            </div>
                                        )}
                                    </div>
                                ))}
                            </div>


                        </div>
                    )}
                    {showPaypalContainer && showPaypal && (
                        <div className="paypal-container" ref={paypalRef}>
                            <PayPalScriptProvider
                                options={{
                                    "client-id": projectInfo?.projectConfig?.config?.PAYPAL_CLIENT_ID,
                                    components: "buttons",
                                    currency: selectedSubscriptionData?.currency,
                                    vault: true,
                                    intent: selectedSubscriptionData?.subscription_type_id === 3 ||
                                        selectedSubscriptionData?.subscription_type_id === 4
                                        ? "subscription"
                                        : "capture",
                                }}
                            >
                                <PaypalButtonWrapper subscriptionData={selectedSubscriptionData} />
                            </PayPalScriptProvider>
                        </div>
                    )}

                </div>
            </div>
        </div>

    )
}

export default Checkout;
